import { gql } from '@apollo/client';
import { MockedResponse } from '@apollo/client/testing';
import { MOCK_CLIENT_ID } from '.';
type FeatureFlagFragment = {
  __typename?: 'FeatureFlag';
  name: string;
  enabled: boolean;
};
export type FeatureFlagsResponse = {
  __typename?: 'Query';
  client: {
    __typename?: 'Client';
    id: string;
    featureFlags: FeatureFlagFragment[];
  };
};
const featureFlagsMock: FeatureFlagFragment[] = [{
  __typename: 'FeatureFlag',
  name: 'client.feedback_thumbs_enabled',
  enabled: true
}, {
  __typename: 'FeatureFlag',
  name: 'client.shop.browse_page_enabled',
  enabled: true
}];
export const getFeatureFlagsResponseMock: FeatureFlagsResponse = {
  __typename: 'Query',
  client: {
    __typename: 'Client',
    id: MOCK_CLIENT_ID || '1234',
    featureFlags: featureFlagsMock
  }
};
export const GetFeatureFlagsDocument = gql`
  query getFeatureFlags(
    $flags: [FeatureFlagInput!]!
    $includeClient: Boolean!
    $includeVisitor: Boolean!
  ) {
    client @include(if: $includeClient) {
      id
      featureFlags(input: $flags) {
        name
        enabled
        __typename
      }
      __typename
    }
    visitor @include(if: $includeVisitor) {
      id
      featureFlags(input: $flags) {
        name
        enabled
        __typename
      }
      __typename
    }
  }
`;
type GetFeatureFlagsVariables = {
  flags: {
    name: string;
  }[];
  includeClient: boolean;
  includeVisitor: boolean;
};
type FeatureFlagsData = {
  __typename: 'Query';
  client: {
    __typename: 'Client';
    id: string;
    featureFlags: {
      __typename: 'FeatureFlag';
      name: string;
      enabled: boolean;
    }[];
  } | null;
  visitor?: {
    __typename: 'Visitor';
    id: string;
    featureFlags: {
      __typename: 'FeatureFlag';
      name: string;
      enabled: boolean;
    }[];
  } | null;
};
export const NEXT_BEST_ACTION_HERO_BANNER_QUERY_FEATURE_FLAG = 'client.web.enable_next_best_action_hero_banner_query';
export const getFeatureFlagsApolloMock = ({
  enabled = true,
  includeClient = true,
  includeVisitor = false,
  clientId = '1234',
  flagName = 'client.feedback_thumbs_enabled',
  flagNames,
  responseFlagNames,
  enabledByFlag,
  maxUsageCount,
  delay
}: Partial<{
  enabled: boolean;
  includeClient: boolean;
  includeVisitor: boolean;
  clientId: string;
  flagName: string;
  flagNames: string[];
  responseFlagNames: string[];
  enabledByFlag: Record<string, boolean>;
  maxUsageCount: number;
  delay: number;
}> = {}): MockedResponse<FeatureFlagsData> => {
  const flags = flagNames ?? [flagName];
  const featureFlags = (responseFlagNames ?? flags).map(name => ({
    __typename: 'FeatureFlag' as const,
    name,
    enabled: enabledByFlag?.[name] ?? enabled
  }));
  return {
    request: {
      query: GetFeatureFlagsDocument,
      variables: {
        flags: flags.map(name => ({
          name
        })),
        includeClient,
        includeVisitor
      } as GetFeatureFlagsVariables
    },
    ...(maxUsageCount !== undefined ? {
      maxUsageCount
    } : {}),
    ...(delay !== undefined ? {
      delay
    } : {}),
    result: {
      data: {
        __typename: 'Query',
        client: includeClient ? {
          __typename: 'Client',
          id: clientId,
          featureFlags
        } : null,
        visitor: includeVisitor ? {
          __typename: 'Visitor',
          id: 'visitor-1',
          featureFlags
        } : null
      }
    }
  };
};
export const getNextBestActionHeroBannerQueryFeatureFlagMock = ({
  enabled = false,
  includeFlag = true,
  delay
}: Partial<{
  enabled: boolean;
  includeFlag: boolean;
  delay: number;
}> = {}) => getFeatureFlagsApolloMock({
  enabled,
  flagName: NEXT_BEST_ACTION_HERO_BANNER_QUERY_FEATURE_FLAG,
  responseFlagNames: includeFlag ? undefined : [],
  delay
});